import { type TaskView } from '@apm/contracts';

/**
 * Việc này có nằm **ngoài kế hoạch PM** không — APM-TASK-creator.
 *
 * ## Vì sao là một hàm, không phải một phép so viết thẳng
 *
 * `createdByPm` có **ba** giá trị, và hai trong số đó không được đối xử giống
 * nhau:
 *
 * - `false` — người tạo không phải PM ⇒ đánh dấu.
 * - `true` — PM tạo ⇒ không đánh dấu.
 * - `null` — **chưa biết** (Replay và bản nháp AI không mang người tạo) ⇒ cũng
 *   không đánh dấu.
 *
 * Viết `!task.createdByPm` thì `null` rơi vào nhánh `true` và mọi việc khi tua
 * lại lịch sử đều mang dấu "người khác tự thêm" — một khẳng định dựng ra từ chỗ
 * không có dữ liệu. Dấu ấy lại xuất hiện ở bốn màn hình (board, danh sách,
 * Gantt, chi tiết), nên luật phải nằm đúng một chỗ.
 */
export function isOffPlan(task: Pick<TaskView, 'createdByPm'>): boolean {
  return task.createdByPm === false;
}
